import { Injectable, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from './localStorage.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private renderer: Renderer2;
  selectedLanguage: string = 'tr';
  private supportedLanguages = ['tr', 'en', 'ar'];

  private languageChange = new BehaviorSubject<string>(this.selectedLanguage);
  languageChange$ = this.languageChange.asObservable();

  constructor(
    public translate: TranslateService,
    private localStorageService: LocalStorageService,
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.initLanguage();
  }

  initLanguage() {
    const storedLang = this.localStorageService.getStore('language');
    const browserLang = this.translate.getBrowserLang() ?? 'tr';
    const lang = storedLang || (this.supportedLanguages.includes(browserLang) ? browserLang : 'tr');

    this.setLanguage(lang);
  }

  setLanguage(lang: string) {
    this.selectedLanguage = lang;
    this.translate.use(lang);
    this.localStorageService.setStore('language', lang);
    this.setDirection(lang);
    this.languageChange.next(lang);
  }

  getLanguages(): string[] {
    return this.supportedLanguages;
  }

  public setDirection(lang: string) {
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
    this.renderer.setAttribute(this.document.documentElement, 'dir', dir);
    this.renderer.setAttribute(this.document.documentElement, 'lang', lang);
  }
  getSavedLanguage(): string {
  return this.localStorageService.getStore('language') || 'tr';
}
applyCurrentLanguage(): void {
  const lang = this.getSavedLanguage();
  this.setLanguage(lang);
}

}
